<template>
    <div class="modal-header">
        <h5 class="modal-title au-head">{{ title }}</h5>
        <button type="button" class="btn-close" :aria-label="$t('common.close')" @click="$emit('close')"></button>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "ModalHeader",
    props: { title: { type: String, required: true } },
    emits: ["close"],
});
</script>

<style scoped>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--au-line);
    padding: 0 0 14px;
}

.modal-title {
    font-size: 19px;
    font-weight: 800;
}

.btn-close {
    border-radius: 10px;
    padding: 8px;
}
</style>